module.exports = __webpack_public_path__ + "static/img/img22.3fa44c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aifv/img22.png
// module id = 1+cO
// module chunks = 1